import React from 'react';
import { Bell, Shield, KeyRound } from 'lucide-react';

export const SettingsPage: React.FC = () => {
  return (
    <div className="page-section">
      <header className="page-heading">
        <div>
          <p className="eyebrow">Workspace Settings</p>
          <h2>Control center</h2>
        </div>
      </header>

      <div className="settings-grid">
        <section className="panel">
          <header className="panel-header">
            <div>
              <p className="eyebrow">
                <Bell size={14} /> Notifications
              </p>
              <h3>Channel alerts</h3>
            </div>
          </header>
          <ul className="settings-list">
            <li>
              <label>
                <span>WhatsApp delivery</span>
                <small>Notify when a customer connects for the first time.</small>
              </label>
              <input type="checkbox" defaultChecked />
            </li>
            <li>
              <label>
                <span>Missed replies</span>
                <small>Daily digest of conversations awaiting response.</small>
              </label>
              <input type="checkbox" />
            </li>
          </ul>
        </section>

        <section className="panel">
          <header className="panel-header">
            <div>
              <p className="eyebrow">
                <Shield size={14} /> Security
              </p>
              <h3>Access control</h3>
            </div>
          </header>
          <ul className="settings-list">
            <li>
              <label>
                <span>Require 2FA</span>
                <small>Force agents to use two-factor authentication.</small>
              </label>
              <input type="checkbox" defaultChecked />
            </li>
            <li>
              <label>
                <span>Session duration</span>
                <small>Log out inactive agents after 12 hours.</small>
              </label>
              <input type="checkbox" defaultChecked />
            </li>
          </ul>
        </section>

        <section className="panel">
          <header className="panel-header">
            <div>
              <p className="eyebrow">
                <KeyRound size={14} /> Integrations
              </p>
              <h3>API credentials</h3>
            </div>
          </header>
          <div className="settings-list">
            <div>
              <p>Trello API Key</p>
              <small>•••••••••••fc16</small>
            </div>
            <button className="ghost-button">Rotate key</button>
          </div>
        </section>
      </div>
    </div>
  );
};
